import React from "react";
import GraphIconButton from '../components/buttons/GraphIconButton';
import { dollarFormat, roundFormat } from "../utils/formatting";
import useUserStore from "../stores/userStore";

const TrendableMetric = ({ label, currentValue, isDollars, graphLabelX, graphLabelY, openModalFn, accessorFn, data, rolesViewableTo }) => {

    const { currentUser } = useUserStore();

    if(rolesViewableTo && !rolesViewableTo.includes(currentUser?.position?.toLowerCase())) return null

    return (
        <p>
            <strong>
                {label}:
                <GraphIconButton   //openModalFn is openTrendModal from trendModalHelper.js
                    onClick={() => openModalFn(label, graphLabelX, graphLabelY, accessorFn, data)} //label, xKey, yKey, keyExtractor, historicPayrolls
                />
            </strong>{" "}
            {isDollars ? dollarFormat(currentValue) : roundFormat(currentValue)}
        </p>
    );
};

export default TrendableMetric;
